// Sharing (F06): native share sheet on mobile, clipboard on desktop.
import { BRAND } from '../brand';
import { track } from '../analytics';

export function absoluteUrl(pathAndQuery: string): string {
  const origin = typeof location !== 'undefined' && location.origin.startsWith('http') ? location.origin : BRAND.siteUrl;
  return new URL(pathAndQuery, origin).toString();
}

export async function share(opts: { url: string; title: string; text?: string; structureId?: string }): Promise<'native' | 'copy' | 'failed'> {
  const nav = navigator as Navigator & { share?: (d: ShareData) => Promise<void>; canShare?: (d: ShareData) => boolean };
  const data = { url: opts.url, title: opts.title, text: opts.text };
  const coarse = typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches;
  if (nav.share && coarse) {
    try {
      await nav.share(data);
      track('share', { structure_id: opts.structureId ?? '', method: 'native' });
      return 'native';
    } catch {
      /* cancelled → fall through to copy */
    }
  }
  try {
    await navigator.clipboard.writeText(opts.url);
    track('share', { structure_id: opts.structureId ?? '', method: 'copy' });
    return 'copy';
  } catch {
    return 'failed';
  }
}
